import React, {useRef, useState} from "react";
import {FaTimes} from "react-icons/fa";
import IMG from "../../../constants/image";

const SearchInput = ({
                         placeholder,
                         onSearch,
                     }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);

    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            // Implement your search logic here
            handleSearch()
        }
    }

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleClear = () => {
        setSearchTerm("");
        inputRef.current.focus();
    };

    const handleSearch = () => {
        // Implement your search logic here
        onSearch && onSearch(searchTerm);
    };

    return (
        <div className="w-full md:w-[380px]">
            <div className="relative">
                <div
                    className={`flex items-center bg-white border rounded-full overflow-hidden transition-all duration-300 ${
                        isFocused ? "border-blue-500  shadow-lg" : "border-gray-300"
                    }`}
                >
                    <input
                        ref={inputRef}
                        type="text"
                        value={searchTerm}
                        onChange={handleInputChange}
                        onKeyDown={onKeyDown}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        placeholder={placeholder}
                        className="w-full py-2 px-4 outline-none text-gray-700"
                        aria-label="Search input"
                    />
                    {searchTerm && (
                        <button
                            onClick={handleClear}
                            className="text-gray-400 hover:text-gray-600 px-2"
                            aria-label="Clear search"
                        >
                            <FaTimes/>
                        </button>
                    )}
                    <button
                        onClick={handleSearch}
                        className="text-white p-2 transition-colors duration-300"
                        aria-label="Perform search"
                    >
                        <img src={IMG.icon.search} alt='search'/>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchInput;
